import { db } from "./db";
import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";

export const fillArticleCuttingSpecsTroTable = () => {
    return db.articleCuttingSpecsTro.count(async function (count: number) {
        if (count > 0) {
            //ArticlesSpec already populated
        } else {
            //ArticlesSpec Database is empty. Populating from ajax call...
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticleCuttingsSpecsTro()
                .then((data) => {
                    //console.log(data)
                    //Got ajax response. We'll now add the objects.
                    //Calling bulkAdd() to insert objects...
                    if (data) {
                        return db.articleCuttingSpecsTro.bulkAdd(data);
                    }
                })
                .then(() => {
                    //Done populating.
                    return db.timestamps.add({ name: "articleCuttingSpecsTro", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}

export const deleteArticleCuttingSpecsTroTable = async () => {
    return db.articleCuttingSpecsTro.clear().then(() => {
        //console.log("Database successfully cleared");
    }).catch((err) => {
        //console.error("Could not clear database");
    })
}

export const updateArticleCuttingSpecsTroTable = async () => {
    await ArticleService.getArticleCuttingsSpecsTro()
        .then(async (data) => {
            await deleteArticleCuttingSpecsTroTable().then(() => {
                //@ts-ignore
                return db.articleCuttingSpecsTro.bulkPut(data);
            })
        })
        .catch(err => console.log(err));
}